import { createTheme } from '@mui/material/styles';

//Este theme fue creado para sobreescribir el margen minimo ante el borde de la pantalla
// que MUI aplica a los Popover (Select, Autocomplete, etc)
const theme = createTheme({
  components: {
    MuiPopover: {
      defaultProps: {
        marginThreshold: 0, 
      },
    },
  },
});

export default theme;
